import { create } from "zustand";
import { persist } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

export const BRAND_MODERATOR_TAB_VALUES = ["review-queue", "rules-engine", "response-playbook", "action-history"] as const;

export type BrandModeratorTab = (typeof BRAND_MODERATOR_TAB_VALUES)[number];

const DEFAULT_BRAND_MODERATOR_TAB: BrandModeratorTab = "review-queue";

function parseBrandModeratorTab(value: unknown): BrandModeratorTab {
  if (typeof value === "string" && (BRAND_MODERATOR_TAB_VALUES as readonly string[]).includes(value)) {
    return value as BrandModeratorTab;
  }
  return DEFAULT_BRAND_MODERATOR_TAB;
}

interface ModerationStore {
  brandModeratorTab: BrandModeratorTab;
  setBrandModeratorTab: (tab: BrandModeratorTab) => void;
}

export const useModerationStore = create<ModerationStore>()(
  persist(
    immer((set) => ({
      brandModeratorTab: DEFAULT_BRAND_MODERATOR_TAB,
      setBrandModeratorTab: (tab) => {
        set((state) => {
          state.brandModeratorTab = tab;
        });
      },
    })),
    {
      name: "zocket-moderation",
      partialize: (state) => ({ brandModeratorTab: state.brandModeratorTab }),
      merge: (persisted, current) => {
        const p = persisted as Partial<Pick<ModerationStore, "brandModeratorTab">> | undefined;
        return {
          ...current,
          brandModeratorTab: parseBrandModeratorTab(p?.brandModeratorTab),
        };
      },
    }
  )
);
